import type { AssetWithAlarms } from 'src/Types/AssetWithAlarms'
import type { SortOrder } from 'src/Types/SortOrder'
import type { OpenedAlarm } from 'src/Types/OpenedAlarm'
import type { Filter } from 'src/Types/Filter'
import { FilterType } from 'src/Types/Filter'
import { sortAssetsWithAlarms } from 'src/Components/SidePanelMenu/sortAssetsWithAlarms'
import { filterAssetsWithAlarms } from 'src/Features/Alarms/AlarmList/AlarmFilters/filterAssetsWithAlarms'

/**
 * Get filtered assets with alarms, plus the assets to show in the object filtering dropdown
 * (which are the assets that match the filters but definitively
 * disregard AssetId filtering - in case it is being used).
 * @param assetsWithAlarms Assets with alarms (AssetWithAlarms[] aka { Asset, Alarm[] })
 * @param sortOrder Current sort order
 * @param openedAlarms Opened alarms
 * @param filters Current filters
 * @param queryLimitOnlyAlarms Whether to limit the query to only assets with alarms
 * @param endOfSearchPeriod The end of the search period used for asset status periods filtering
 * @param usingUnsafeSorting Whether to use unsafe sorting
 */
export const getFilteredAndAssetsForIdFiltering = (
  assetsWithAlarms: AssetWithAlarms[],
  sortOrder: SortOrder,
  openedAlarms: OpenedAlarm[],
  filters: Filter[],
  queryLimitOnlyAlarms: boolean,
  endOfSearchPeriod?: number,
  usingUnsafeSorting: boolean = false
) => {
  const sortedAssetsWithAlarms = sortAssetsWithAlarms(assetsWithAlarms, sortOrder, openedAlarms, usingUnsafeSorting)

  const getFilteredAssetsAndAlarms = (theseFilters: Filter[]) =>
    filterAssetsWithAlarms(theseFilters, sortedAssetsWithAlarms, queryLimitOnlyAlarms, endOfSearchPeriod)

  const filteredByAllFilters = getFilteredAssetsAndAlarms(filters)

  const filteredWithoutAssetIdFilter = getFilteredAssetsAndAlarms(filters.filter(f => f.type !== FilterType.AssetId))

  return {
    filteredAssetsWithAlarms: filteredByAllFilters,
    assetsForIdFiltering: filteredWithoutAssetIdFilter.map(a => a.asset),
  }
}
